<autocomplete-list-item (clicked)="triggerEvent()"> {{ item.translation.de }} </autocomplete-list-item>
